import mixpanel from 'mixpanel-browser';
import {MixpanelEvent} from '../common/enums/mixpanel-event';
import { getIsReactNativeWrapper, getWrapperPlatform } from '../App';

export const mixpanelTrack = (name: MixpanelEvent, data = {}) => {
  try {
    const isRNWrapper = getIsReactNativeWrapper();
    const platform = getWrapperPlatform();
    mixpanel.track(name, {
      ...data,
      platform_source: isRNWrapper ? (platform + '_app') : 'web'
    });
  } catch {
  }
};
